module.exports = __webpack_public_path__ + "static/media/fillbucket.cabe9792.svg";